"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Form;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
function Form(_a) {
    var { form, onSubmit, formId, children } = _a, props = __rest(_a, ["form", "onSubmit", "formId", "children"]);
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.FormProvider, Object.assign({}, form, { children: (0, jsx_runtime_1.jsx)(material_1.Box, Object.assign({ component: "form", 
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onSubmit: form.handleSubmit(onSubmit), noValidate: true, id: formId }, props, { children: children })) })));
}
//# sourceMappingURL=Form.js.map